module.exports = __webpack_public_path__ + "static/media/SI.5a396bf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SI.svg
// module id = 358
// module chunks = 0